module.exports = "<div class=\"container-portfolio\">\n  <h1 style=\"text-align: center\">En actualización...</h1>\n</div>"